<template>
    <picture
        v-if="src"
        class="o-asset"
    >
        <source
            v-if="webpSrcset"
            :data-srcset="webpSrcset"
            type="image/webp"
        >
        <source
            v-if="srcset"
            :data-srcset="srcset"
            :type="mimeType"
        >
        <img
            :alt="alt"
            :data-src="src"
            data-sizes="auto"
            loading="lazy"
            @load="$emit('imageLoaded')"
            class="o-asset__img | lazyload"
        >
    </picture>
</template>

<script>/* eslint-disable */
import 'lazysizes';

export default {
    name: 'Asset',
    props: {
        alt: {
            type: String,
            default: ''
        },
        src: {
            type: String,
            default: null,
            required: true
        },
        srcset: {
            type: String,
            default: null
        },
        webpSrcset: {
            type: String,
            default: null
        },
        webpAuto: {
            type: Boolean,
            default: false
        }
    },
    computed: {

        srcExtension() {
            const _image = this.src
            return (/[.]/.exec(_image)) ? /[^.]+$/.exec(_image) : undefined;
        },
        mimeType() {
            const ext = this.srcExtension
            const mimeType = (ext === 'jpg') ? 'jpeg' : ext
            return `image/${mimeType}`
        }
    }
}
</script>
